(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  /*
   * Move the Seal Subscriptions widget below the Bundler volume discount and
   * directly above the add-to-cart button. Both widgets are injected by their
   * apps at runtime (and may re-render when the variant changes), so for each
   * product-info section we watch for the Seal widget and reposition it into
   * the buy-buttons form. The move is idempotent and rAF-debounced; the
   * observer disconnects once placed (or after a timeout) to avoid lingering.
   *
   * The same pass also flags whether the quantity selector is actually
   * visible. The bundler hides it when its own volume-break selector takes
   * over, and the add-to-cart button must then span the full width instead of
   * reserving space next to an invisible selector.
   */
  (() => {
    const SETTLE_MS = 10000;

    // Mark the buy-row when the quantity selector is not rendered, so the CSS
    // can drop the space reserved for it.
    const syncQtyVisibility = (buyRow) => {
      const qty = buyRow && buyRow.querySelector('.product-form__quantity');
      if (!buyRow) return;
      buyRow.classList.toggle('is-qty-hidden', !qty || qty.offsetParent === null);
    };

    // Returns true once the Seal widget has rendered visible content and is
    // sitting just above the add-to-cart button — i.e. nothing left to wait for.
    const place = (scope) => {
      const atc = scope.querySelector('.product-form__buttons');
      const buyRow = atc && atc.closest('.buy-row');
      syncQtyVisibility(buyRow);

      const seal = scope.querySelector('.sealsubs-target-element');
      if (!seal || !atc || !atc.parentNode) return false;

      // Move the widget directly above the add-to-cart button (idempotent).
      if (atc.previousElementSibling !== seal) {
        atc.parentNode.insertBefore(seal, atc);
      }

      // Only stack the buy-row once the widget actually has content; an empty
      // placeholder must not push the quantity selector around.
      const hasContent = seal.offsetHeight > 0;
      if (buyRow) buyRow.classList.toggle('is-stacked', hasContent);
      return hasContent;
    };

    const watch = (scope) => {
      // Keep observing even when the Seal widget settles early: the bundler
      // may hide the quantity selector afterwards, and that has to be picked
      // up until the settle timeout.
      place(scope);

      let scheduled = false;
      const run = () => {
        scheduled = false;
        place(scope);
      };
      const obs = new MutationObserver(() => {
        if (scheduled) return;
        scheduled = true;
        requestAnimationFrame(run);
      });
      const timer = setTimeout(stop, SETTLE_MS);
      function stop() {
        clearTimeout(timer);
        obs.disconnect();
      }
      obs.observe(scope, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['style', 'class', 'hidden'],
      });
    };

    document.querySelectorAll('product-info').forEach(watch);
  })();

  } catch(e) { console.error(e); }
})();
})();
